import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100vh"
          image={`url(${mobileHero}) top / cover no-repeat`}
          column
          alignCenter
        >
          <CFView textCenter w="100%" mt="30px">
            <CFView>
              <CFImage
                w="95%"
                src={mobileHeroText}
                alt="Sushi wara hero text"
                zIndex={98}
              />
            </CFView>
            <CFView pulsate mt="30px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="680px"
          w="100%"
          image={`url(${hero}) center/ cover no-repeat`}
          zIndex={90}
          column
          justifyCenter
          alignStart
        >
          <CFView column justifyCenter alignStart ml="105px" mt="-20px">
            <CFImage
              w="550px"
              src={heroText}
              alt="Sushi wara hero text"
              zIndex={98}
            />
            <CFView pulsate mt="50px" ml="25px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
